import React, { useState, useEffect } from 'react';
import Entities, {XmlEntities} from 'html-entities';
import BlockDisplay from './BlockDisplay';
import { Input, Popover } from 'antd';
 
const entities = new XmlEntities();

function HighlightItem({setCodeBlock}) {
  const [heading, setHeading] = useState("Vintage Pieces");
  const [subHeading, setSubHeading] = useState("Hand Selected");
  const [text, setText] = useState("Lorem ipsum dolor sit amet, consectetur adipiscing. Unique vintage pieces we've found for you.");
  const [buttonText, setButtonText] = useState("Discover");
  const [buttonLink, setButtonLink] = useState("https://artisan-default-demo.mybigcommerce.com/collections/by-style/vintage/");
  const [highlightImage, setHighlightImage] = useState("https://cdn11.bigcommerce.com/s-aas6vytuee/product_images/uploaded_images/highlight.png");
  const tooltip = (
    <div>
      <span>To accomplish the same effect as the demo store, please use these dimensions.</span>
    </div>
  );

  const codeBlock = `<div class="container">
  <div class="highlight-item">
      <div class="highlight-img"><a href="${entities.encode(buttonLink)}"><img src="${entities.encode(highlightImage)}"></a></div>
      <div class="highlight-text">
          <h2>${entities.encode(heading)}</h2>
          <h4><i>${entities.encode(subHeading)}</i></h4>
          <p>${entities.encode(text)}</p>
          <a href="${entities.encode(buttonLink)}" class="button">${entities.encode(buttonText)}</a>
      </div>
  </div>
</div>`;

  useEffect(() => {
    setCodeBlock(codeBlock);
  }, [codeBlock]);

  return (
    <div className="singleBlock">
      <div className="sidebar">
        <h2>Highlight Image Block</h2>
        <label>
          <span>Heading</span>
          <Input type="text" value={heading} onChange={(evt) => setHeading(evt.target.value)} />
        </label>
        <label>
          <span>Sub Heading</span>
          <Input type="text" value={subHeading} onChange={(evt) => setSubHeading(evt.target.value)} />
        </label>
        <label>
          <span>Text</span>
          <Input type="text" value={text} onChange={(evt) => setText(evt.target.value)} />
        </label>
        <label>
          <span>Button Text</span>
          <Input type="text" value={buttonText} onChange={(evt) => setButtonText(evt.target.value)} />
        </label>
        <label>
          <span>Button Link</span>
          <Input type="text" value={buttonLink} onChange={(evt) => setButtonLink(evt.target.value)} />
        </label>
        <label>
        <span>Image&nbsp;
            <Popover content={tooltip}>
              <a href="javascript:void(0)">(Width: 700px - Height: 700px)</a>
            </Popover>
          </span>
          <Input type="text" value={highlightImage} onChange={(evt) => setHighlightImage(evt.target.value)} />
        </label>
      </div>
      <BlockDisplay codeBlock={codeBlock}/>
    </div>
  )
}

export default HighlightItem;
